import { useTranslation } from '@/shared/core/hooks/use-translation/use-translation.ts'
import { ScrollIndicator } from '@/teams/portfolio/components/scroll-indicator/scroll-indicator.tsx'
import { AiIndicator } from '@/teams/portfolio/components/section/home-section/ai-indicator/ai-indicator.tsx'
import { HomeContent } from '@/teams/portfolio/components/section/home-section/home-content/home-content.tsx'
import { Section } from '@/teams/portfolio/components/section/section/section.tsx'
import '@/teams/portfolio/components/section/home-section/home-section.scss'

export function HomeSection() {
	const { t } = useTranslation()

	return (
		// biome-ignore lint/correctness/useUniqueElementIds: Static ID needed for URL anchor navigation
		<Section ariaLabel={t('portfolio.section.home.ariaLabel')} id='home'>
			<div className='home-section'>
				<HomeContent />
				<AiIndicator />
				<ScrollIndicator targetSection='skills' />
			</div>
		</Section>
	)
}
